// Lib
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import Settings from "@mui/icons-material/Settings";
import {
  CalendarDate,
  CalendarDateTime,
  getLocalTimeZone,
  toCalendarDate,
  today,
  ZonedDateTime,
} from "@internationalized/date";
import { RangeValue } from "@react-types/shared";

// Local
import { DbRead } from "../../database";
import CallsListPage from "./CallsListPage";
import type { ExistingStiltPhoneCall } from "../../models/calls";
import VoipSettingsDialog from "../../components/calls/VoipSettingsDialog";
import DateRangePicker from "../../components/DateRangePicker";
import { logger } from "../../logging";

interface Props {
  siteKey: string;
}

export default function CallsListContainer(props: Props): JSX.Element {
  const siteKey = props.siteKey;
  // const navigationType = useNavigationType();

  const [calls, setCalls] = useState<ExistingStiltPhoneCall[]>([]);
  // const [didComeFromBack, setDidComeFromBack] = useState(false);
  const [isVoipSettingsOpen, setIsVoipSettingsOpen] = useState(false);

  const [range, setRange] = useState<RangeValue<CalendarDate>>({
    start: today(getLocalTimeZone()).subtract({ days: 30 }),
    end: today(getLocalTimeZone()),
  });

  // if user got to this page from back button, set "didComeFromBack" to true
  /*
  useEffect(() => {
    if (navigationType === "POP") {
      setDidComeFromBack(true);
    }
  }, [navigationType]);
  */

  function handleDateRangeChange(
    value: RangeValue<CalendarDate | ZonedDateTime | CalendarDateTime>,
  ) {
    logger.debug(
      `Invoked handleDateRangeChange for range: ${value.start.month}-${value.start.day} to ${value.end.month}-${value.end.day}`,
    );
    try {
      const convertedStart = toCalendarDate(value.start);
      const convertedEnd = toCalendarDate(value.end);
      setRange({ start: convertedStart, end: convertedEnd });
      logger.debug(
        `set range to ${convertedStart.month}-${convertedStart.day} to ${convertedEnd.month}-${convertedEnd.day}`,
      );
    } catch (e) {
      logger.error(
        `CallsListContainer: handleDateRangeChange${e instanceof Error ? `: ${e.message}` : ""}`,
        e,
      );
    }
  }

  useEffect(() => {
    function getCalls() {
      return DbRead.calls.subscribeAllInDateRange({
        siteKey: siteKey,
        dateRange: range,
        onChange: setCalls,
        onError: logger.error,
      });
    }

    const unsubscribeFn = getCalls();
    return () => unsubscribeFn();
  }, [siteKey, range]);

  // const audioPlayer =  callRecordingURL ? <div className="mx-0">
  //     <AudioPlayer
  //       style={{
  //         padding: "2px",
  //         background: "transparent",
  //         boxShadow: "none",
  //       }}
  //       src={callRecordingURL}
  //       showJumpControls={false}
  //       layout={"horizontal-reverse"}
  //       customVolumeControls={[]}
  //       customAdditionalControls={[]}
  //     />
  //   </div> : null

  const dateRangePicker = (
    <DateRangePicker value={range} onChange={handleDateRangeChange} />
  );

  const voipSettingsButton = (
    <div className="flex items-center justify-between">
      <Button
        variant="outlined"
        startIcon={<Settings />}
        onClick={() => setIsVoipSettingsOpen(true)}
      >
        Call Integration Settings
      </Button>
    </div>
  );
  const voipSettingsDialog = (
    <VoipSettingsDialog
      open={isVoipSettingsOpen}
      onClose={() => setIsVoipSettingsOpen(false)}
    />
  );

  return (
    <>
      {voipSettingsDialog}

      <CallsListPage calls={calls}>
        {{
          dateRangePicker: dateRangePicker,
          voipSettingsBtn: voipSettingsButton,
        }}
      </CallsListPage>
    </>
  );
}
